"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemCheckbox = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const menu_item_styles_1 = require("@/components/common/menu-item/menu-item.styles");
const menu_item_utils_1 = require("@/components/common/menu-item/menu-item.utils");
require("@/components/common/checkbox");
let MenuItemCheckbox = class MenuItemCheckbox extends (0, menu_item_utils_1.withMenuItemToggleState)((0, menu_item_utils_1.withMenuItemPresentation)(lit_1.LitElement)) {
    // menu 밖(체크 그룹)에서 쓰이므로 menuitemcheckbox가 아니라 checkbox로 둔다.
    render() {
        return (0, menu_item_utils_1.renderMenuItemToggleRow)(this, 'checkbox', this.renderAction());
    }
    renderAction() {
        // 행(row)이 role·상태·상호작용을 소유하므로 내부 컨트롤은 시각 표시 전용(inert)이다.
        return (0, lit_1.html) `
      <mm-checkbox
        slot="trailing"
        inert
        aria-hidden="true"
        .checked=${this.checked}
        ?disabled=${this.disabled}
      ></mm-checkbox>
    `;
    }
};
MenuItemCheckbox.styles = [menu_item_styles_1.menuItemStyles];
MenuItemCheckbox = __decorate([
    (0, decorators_js_1.customElement)('mm-menu-item-checkbox')
], MenuItemCheckbox);
exports.MenuItemCheckbox = MenuItemCheckbox;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVudS1pdGVtLWNoZWNrYm94LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibWVudS1pdGVtLWNoZWNrYm94LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFzQztBQUN0QyxxREFBaUQ7QUFFakQscUZBQStFO0FBQy9FLG1GQUlzRDtBQUN0RCx3Q0FBcUM7QUFHOUIsSUFBTSxnQkFBZ0IsR0FBdEIsTUFBTSxnQkFBaUIsU0FBUSxJQUFBLHlDQUF1QixFQUMzRCxJQUFBLDBDQUF3QixFQUFDLGdCQUFVLENBQUMsQ0FDckM7SUFHQywyREFBMkQ7SUFDM0QsTUFBTTtRQUNKLE9BQU8sSUFBQSx5Q0FBdUIsRUFBQyxJQUFJLEVBQUUsVUFBVSxFQUFFLElBQUksQ0FBQyxZQUFZLEVBQUUsQ0FBQyxDQUFBO0lBQ3ZFLENBQUM7SUFFTyxZQUFZO1FBQ2xCLHlEQUF5RDtRQUN6RCxPQUFPLElBQUEsVUFBSSxFQUFBOzs7OzttQkFLSSxJQUFJLENBQUMsT0FBTztvQkFDWCxJQUFJLENBQUMsUUFBUTs7S0FFNUIsQ0FBQTtJQUNILENBQUM7O0FBbEJNLHVCQUFNLEdBQUcsQ0FBQyxpQ0FBYyxDQUFDLENBQUE7QUFIckIsZ0JBQWdCO0lBRDVCLElBQUEsNkJBQWEsRUFBQyx1QkFBdUIsQ0FBQztHQUMxQixnQkFBZ0IsQ0FzQjVCO0FBdEJZLDRDQUFnQiJ9